import {
  SubcategoryGridCount,
  SubcategoryGridName,
  SubcategoryGridThumb,
  SubcategoryGridThumbPlaceholder,
  SubcategoryGridTile,
  SubcategoryGridTileLabel,
} from '@vs-shop/commerce-ui/subcategoryGrid';
import { ImageMissingPlaceholder } from '@vs-shop/ui/imageMissingPlaceholder';
import { coalesceNonEmpty } from '@vs-shop/domain/string/coalesceNonEmpty';

import { resolveImageUrl } from '@vs-shop/engine/image/resolveImageUrl';

import type { TaxonExpandedResponse } from '@vs-shop/schemas/taxon/taxon';
import { ImageFilter } from '@vs-shop/engine/image/ImageFilter';

/**
 * One taxon, projected onto the shared subcategory tile.
 *
 * The projection is what stays here: a whole taxon carries images, router URLs,
 * meta titles and counts, and the shared parts take a resolved URL, a label and
 * an href. Resolving the media path against the CDN and choosing the Liip
 * filter is rcprofi's pipeline and stays app-side.
 */

type Props = {
  taxon: TaxonExpandedResponse;
};

export default function CategoryCategoriesGridItem({ taxon }: Props) {
  const images = taxon.images ?? [];
  const imageMain = images[0] ?? null;
  const imagePath = imageMain?.pathAbstract
    ? resolveImageUrl(imageMain.pathAbstract, ImageFilter.product_gallery_modal_thumbnail)
    : null;

  const name = taxon.nameInTaxonList ?? taxon.name ?? '';
  const title = coalesceNonEmpty(taxon.metaTitle, taxon.name, taxon.nameInTaxonList) ?? '';

  return (
    <SubcategoryGridTile href={taxon.routerUrl} title={title} prefetch={false}>
      <SubcategoryGridTileLabel>
        {imagePath !== null ? (
          <SubcategoryGridThumb src={imagePath} alt={title} width={71} height={53} />
        ) : (
          <SubcategoryGridThumbPlaceholder>
            <ImageMissingPlaceholder className="size-5 lap:size-10" />
          </SubcategoryGridThumbPlaceholder>
        )}

        <SubcategoryGridName>{name}</SubcategoryGridName>
      </SubcategoryGridTileLabel>

      <SubcategoryGridCount>{taxon.totalProducts}</SubcategoryGridCount>
    </SubcategoryGridTile>
  );
}
